// extracted by mini-css-extract-plugin
module.exports = {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","color-black":"#000000","colorBlack":"#000000","buttonMultiply":"_1TYxF","buttonBuyNow":"_2c3wZ"};